<div
  class="notification-type-list"
  [caLocalizationScope]="localizationScope"
  data-automation-id="notification-type-list"
>
  <!-- Type Header (collapsible) -->
  <div
    class="notification-type-list__header d-flex align-items-center justify-content-between p-2 cursor-pointer"
    (click)="toggleExpanded()"
    [attr.data-automation-id]="'type-header-' + notificationsByType().notificationTypeCode"
  >
    <div class="d-flex align-items-center gap-2">
      <i class="f-i f-i-sm" [class.f-i-caret-down]="isExpanded()" [class.f-i-caret-right]="!isExpanded()"> </i>
      <span class="fw-semibold">
        {{ typeLabelKey() | caLocalize }}
      </span>
      @if (notificationsByType().unreadCount > 0) {
      <span class="text-muted small">({{ notificationsByType().unreadCount }})</span>
      }
    </div>
  </div>

  <!-- Notification Items — only rendered when section is expanded.
       Collapse hides the entire content including controls; the show-more/less
       state (showingAll signal) is preserved so re-expanding restores the view. -->
  @if (isExpanded()) {
  <div class="notification-type-list__content">
    @if (notificationsByType().notifications.length === 0) {
    <div class="p-3 text-muted small text-center">
      {{ 'noTypeNotifications' | caLocalize }}
    </div>
    } @for (notification of displayedNotifications(); track notification.notificationId) {
    <ca-notification-item-renderer
      [notification]="notification"
      [typeCode]="notificationsByType().notificationTypeCode"
      (markAsRead)="onMarkAsRead($event)"
      (delete)="onDelete($event)"
    >
    </ca-notification-item-renderer>
    <hr class="my-0" />
    }

    <!-- Show More / Show Less -->
    @if (canToggle()) {
    <div class="p-2">
      @if (isLoadingMore()) {
      <div class="d-flex align-items-center gap-1 text-muted small">
        <span class="spinner-border spinner-border-sm" role="status"></span>
        {{ 'loading' | caLocalize }}
      </div>
      } @else { @if (canShowMore()) {
      <a
        class="link link-main"
        [class.me-3]="canShowLess()"
        role="button"
        (click)="onShowMore()"
        data-automation-id="show-more-btn"
      >
        {{ 'showMore' | caLocalize }}
      </a>
      } @if (canShowLess()) {
      <a class="link link-main" role="button" (click)="onShowLess()" data-automation-id="show-less-btn">
        {{ 'showLess' | caLocalize }}
      </a>
      } }
    </div>
    }
  </div>
  }
</div>
